var EventStrategy = /** @class */ (function () {
    function EventStrategy(context, props) {
        this.context = context;
        this.props = props;
    }
    return EventStrategy;
}());
export { EventStrategy };
//# sourceMappingURL=EventStrategy.js.map